import { Icon, ReadOnlyField, TableColumnType, Tooltip } from '@elipssolution/harfang';
import { mdiEarth, mdiLock } from '@mdi/js';
import { Avatar, styled } from '@mui/material';

import { renderFullName } from '../../../utils/renderFullName';
import SignersAvatarGroup from '../components/SignersAvatarGroup';
import { ProcedureType } from '../types/procedure';

const TableReadOnlyField = styled(ReadOnlyField)({
	height: 20,
});

export const baseProcedureColumns: TableColumnType<ProcedureType>[] = [
	{
		align: 'center',
		flexGrow: 0,
		field: 'isPrivate',
		key: 'isPrivate',
		title: '',
		render: ({ isPrivate }) => (
			<Tooltip content={isPrivate ? 'Privée' : 'Publique'} placement="right">
				<Icon path={isPrivate ? mdiLock : mdiEarth} />
			</Tooltip>
		),
		width: 24,
	},
	{
		field: 'name',
		key: 'name',
		sortable: true,
		title: 'Nom',
		render: ({ name }) => <TableReadOnlyField value={name} scrollable={false} />,
		width: 200,
		flexGrow: 1,
	},
	{
		field: 'signers',
		key: 'signers',
		title: 'Signataires',
		render: ({ signers }) => <SignersAvatarGroup signers={signers} />,
		width: 100,
		flexGrow: 0,
	},
	{
		field: 'createdBy',
		key: 'createdBy',
		title: 'Créé par',
		render: ({ createdBy: { firstName, lastName } }) => (
			<Tooltip content={renderFullName({ firstName, lastName })}>
				<Avatar sx={{ height: 36, width: 36 }}>{`${firstName?.[0] ?? ''}${lastName[0]}`}</Avatar>
			</Tooltip>
		),
		width: 100,
		flexGrow: 0,
	},
	{
		field: 'updatedAt',
		key: 'updatedAt',
		sortable: true,
		title: 'Modifié le',
		render: ({ updatedAt }) => updatedAt.toLocaleDateString('fr-FR'),
		width: 100,
		flexGrow: 0,
	},
];
